<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
        <v-img
          :src="require('../assets/gpstrategy.png')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-flex>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          ANÁLITICA CUADRO DE MANDO INTEGRAL
        </h1>
        <p class="subheading font-weight-regular">
          VECOL S.A. tiene como objeto promover y estimular el incremento de la producción agropecuaria y sus insumos, así como el mejoramiento de la salud humana y animal, mediante la producción, venta, comercialización, importación, exportación e investigación científica de productos biotecnológicos, químicos, farmacéuticos, agrícolas e industriales
          <br>
          <a href="https://www.gpstrategy.com.co/" target="_blank"></a>
        </p>
      </v-flex>

      <v-flex
        mb-5
        xs12
      >
        <h2 class="headline font-weight-bold mb-3">Misión: 

Somos una empresa que investiga, desarrolla, fabrica y comercializa productos para promover la salud, la productividad del sector agropecuario y el bienestar del ser humano.</h2>


      </v-flex>

      <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3">Links Importantes</h2>

        <v-layout justify-center>
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-layout>
      </v-flex>

      <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3"></h2>

        <v-layout justify-center>
          <a
            v-for="(eco, i) in quienesomos"
            :key="i"
            :href="eco.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ eco.text }}
          </a>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
   quienesomos: [
      {
        text: 'vuetify-loader',
        href: 'https://www.vecol.com.co/quienes_somos/objeto-social-funciones',
      },
      {
        text: 'github',
        href: 'https://github.com/vuetifyjs/vuetify',
      },
      {
        text: 'awesome-vuetify',
        href: 'https://github.com/vuetifyjs/awesome-vuetify',
      },
    ], 
    importantLinks: [
      {
        text: 'Quienes somos',
        href: 'https://www.vecol.com.co/quienes_somos/objeto-social-funciones',
      },
      {
        text: 'Productos',
        href: 'https://www.vecol.com.co/productos',
      },
      {
        text: 'Soporte',
        href: 'https://www.vecol.com.co/soporte-tecnico',
      },
      {
        text: 'Proyectos',
        href: 'https://www.vecol.com.co/proyectos',
      },
      {
        text: 'Vecol para niños',
        href: 'https://www.vecol.com.co/vecol-para-ninos',
      },
    ],
  }),
};
</script>
